import React from "react";
import {
  Box,
  Modal,
  IconButton,
  Fade,
  Backdrop,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

interface ImageGridModalProps {
  open: boolean;
  onClose: () => void;
  images: string[];
  selectedIndex: number | null;
  onPrev: () => void;
  onNext: () => void;
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchEnd: (e: React.TouchEvent) => void;
}

const ImageGridModal: React.FC<ImageGridModalProps> = ({
  open,
  onClose,
  images,
  selectedIndex,
  onPrev,
  onNext,
  onTouchStart,
  onTouchEnd,
}) => {
  const currentImage = selectedIndex !== null ? images[selectedIndex] : null;

  if (!currentImage) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.9)",
        },
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1400,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "relative",
            width: "90%",
            maxWidth: "90vw",
            height: "90%",
            maxHeight: "90vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "#fff",
              bgcolor: "rgba(0,0,0,0.5)",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.7)",
              },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          {images.length > 1 && (
            <>
              <IconButton
                onClick={onPrev}
                sx={{
                  position: "absolute",
                  left: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",
                  "&:hover": {
                    bgcolor: "rgba(0,0,0,0.7)",
                  },
                  zIndex: 1,
                }}
              >
                <ChevronLeftIcon />
              </IconButton>
              <IconButton
                onClick={onNext}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",
                  "&:hover": {
                    bgcolor: "rgba(0,0,0,0.7)",
                  },
                  zIndex: 1,
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </>
          )}
          <Box
            component="img"
            src={currentImage}
            alt={`Zoomed image ${selectedIndex! + 1}`}
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
          {images.length > 1 && (
            <Typography
              sx={{
                position: "absolute",
                bottom: 16,
                left: "50%",
                transform: "translateX(-50%)",
                color: "#fff",
                bgcolor: "rgba(0,0,0,0.5)",
                px: 2,
                py: 0.5,
                borderRadius: 1,
              }}
            >
              {selectedIndex! + 1} / {images.length}
            </Typography>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ImageGridModal;
